const toggleSpecifications = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const rows = document.querySelectorAll('.br-specifications__item');
        const toggleSpecificationsButton = document.querySelector('.br-specifications__button');

        if (toggleSpecificationsButton) {
            if (rows.length > 4) {
                toggleSpecificationsButton.style.display = 'flex';
                initializeToggleSpecificationsButtonEvent(toggleSpecificationsButton);
            } else {
                toggleSpecificationsButton.style.display = 'none';
            }
        }
    });
};

const initializeToggleSpecificationsButtonEvent = (toggleSpecificationsButton) => {
    const table = document.querySelector('.br-specifications__table');

    toggleSpecificationsButton.addEventListener('click', function () {
        var showAllRow = toggleSpecificationsButton.classList.contains('close');

        if (showAllRow) {
            table.classList.remove('-hiderow');
        } else {
            table.classList.add('-hiderow');
        }
        toggleSpecificationsButton.classList.toggle('open', showAllRow);
        toggleSpecificationsButton.classList.toggle('close', !showAllRow);
    });
};

toggleSpecifications();
